import React, { useState, useContext, useEffect } from "react";

//router
import { Link, useLocation } from "react-router-dom";

//react-bootstrap
import {
  Accordion,
  useAccordionButton,
  AccordionContext,
  Nav,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { userProfile } from "../../../../store/user/userThunk";

const VerticalNav = React.memo(() => {
  let { profile } = useSelector((state) => state.userservice);

  //location
  let location = useLocation();
  let dispatch = useDispatch();

  useEffect(() => {
    dispatch(userProfile());
  }, []);

  // Custom icon components for better consistency
  const DashboardIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
    </svg>
  );

  const ProfileIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
  );

  const InboxIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
    </svg>
  );

  const TemplateIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  );

  const TelegramIcon = () => (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
    </svg>
  );

  const AutochatIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
    </svg>
  );

  const QuickReplyIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" />
    </svg>
  );

  const HelpIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  );

  return (
    <div className="vertical-nav">
      <Accordion as="ul" className="space-y-1">
        {/* Main Section Header */}
        <li className="px-3 py-2">
          <div className="text-xs font-semibold text-gray-400 uppercase tracking-wider">
            Main
          </div>
        </li>

        {/* Dashboard */}
        <li className="nav-item my-2 ">
          <Link
            className={`w-full flex items-center justify-between rounded-lg text-left transition-all duration-200 nav-link p-3  ${location.pathname === "/dashboards"
              ? "bg-[#50B5FF] text-white active"
              : "text-gray-700 hover:bg-gray-100"
              }`}
            to="/dashboards"
          >
            <div className="flex items-center">
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip>View your dashboard</Tooltip>}
              >
                <div
                  className={`mr-3 flex-shrink-0  ${location.pathname === "/dashboards" ? "text-white" : "text-gray-500"
                    }`}
                >
                  <DashboardIcon />
                </div>
              </OverlayTrigger>
              <span className="font-medium item-name">Dashboard</span>
            </div>
          </Link>
        </li>

        {/* Profile */}
        {(profile?.iglogin === true || profile?.Fblogin === true) && (
          <li className="nav-item">
            <Link
              className={`nav-link flex items-center  rounded-lg text-sm font-medium transition-all duration-200 group p-3 ${location.pathname === "/dashboards/profiles"
                ? "bg-[#50B5FF] text-white shadow-md"
                : "text-gray-700 hover:bg-[#D5EDFF] hover:text-[#50B5FF]"
                }`}
              to="/dashboards/profiles"
            >
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip>View your Profile</Tooltip>}
              >
                <div className={`mr-3 ${location.pathname === "/dashboards/profiles" ? "text-white" : "text-gray-500 group-hover:text-[#50B5FF]"}`}>
                  <ProfileIcon />
                </div>
              </OverlayTrigger>
              <span className="item-name">Profile</span>
            </Link>
          </li>
        )}

        {/* Inbox */}
        {(profile?.iglogin === true || profile?.wpLogin === true || profile?.Fblogin === true) && (
          <li className="nav-item">
            <Link
              className={`nav-link flex items-center  rounded-lg text-sm font-medium transition-all duration-200 group p-3 ${location.pathname === "/chat/inbox"
                ? "bg-[#50B5FF] text-white shadow-md"
                : "text-gray-700 hover:bg-[#D5EDFF] hover:text-[#50B5FF]"
                }`}
              to="/chat/inbox"
            >
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip>View your inbox</Tooltip>}
              >
                <div className={`mr-3 ${location.pathname === "/chat/inbox" ? "text-white" : "text-gray-500 group-hover:text-[#50B5FF]"}`}>
                  <InboxIcon />
                </div>
              </OverlayTrigger>
              <span className="item-name">Inbox</span>
            </Link>
          </li>
        )}

        {/* WhatsApp Template */}
        {profile?.wpLogin === true && (
          <li className="nav-item">
            <Link
              className={`nav-link flex items-center  rounded-lg text-sm font-medium transition-all duration-200 group p-3 ${location.pathname === "/dashboards/app/template"
                ? "bg-[#50B5FF] text-white shadow-md"
                : "text-gray-700 hover:bg-[#D5EDFF] hover:text-[#50B5FF]"
                }`}
              to="/dashboards/app/template"
            >
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip>Set whatsapp templates</Tooltip>}
              >
                <div className={`mr-3 ${location.pathname === "/dashboards/app/template" ? "text-white" : "text-gray-500 group-hover:text-[#50B5FF]"}`}>
                  <TemplateIcon />
                </div>
              </OverlayTrigger>
              <span className="item-name">Template</span>
            </Link>
          </li>
        )}

        {/* Telegram Chat */}
        {profile?.tgLogin === true && (
          <li className="nav-item">
            <Link
              className={`nav-link flex items-center  rounded-lg text-sm font-medium transition-all duration-200 group p-3 ${location.pathname === "/chat/telegram-chat"
                ? "bg-[#50B5FF] text-white shadow-md"
                : "text-gray-700 hover:bg-[#D5EDFF] hover:text-[#50B5FF]"
                }`}
              to="/chat/telegram-chat"
            >
              <div className={`mr-3 ${location.pathname === "/chat/telegram-chat" ? "text-white" : "text-gray-500 group-hover:text-[#50B5FF]"}`}>
                <TelegramIcon />
              </div>
              <span className="item-name">Telegram Chat</span>
            </Link>
          </li>
        )}

        {/* Autochat */}
        <li className="nav-item">
          <Link
            className={`nav-link flex items-center  rounded-lg text-sm font-medium transition-all duration-200 group p-3 ${location.pathname === "/dashboards/extrapages/pages-autochat"
              ? "bg-[#50B5FF] text-white shadow-md"
              : "text-gray-700 hover:bg-[#D5EDFF] hover:text-[#50B5FF]"
              }`}
            to="/dashboards/extrapages/pages-autochat"
          >
                <OverlayTrigger
                placement="right"
                overlay={<Tooltip>Set autochat</Tooltip>}
              >
            <div className={`mr-3 ${location.pathname === "/dashboards/extrapages/pages-autochat" ? "text-white" : "text-gray-500 group-hover:text-[#50B5FF]"}`}>
              <AutochatIcon />
            </div>
            </OverlayTrigger>
            <span className="item-name">Autochat</span>
          </Link>
        </li>

        {/* Quick Reply */}
        <li className="nav-item">
          <Link
            className={`nav-link flex items-center  rounded-lg text-sm font-medium transition-all duration-200 group p-3 ${location.pathname === "/dashboards/extrapages/pages-quickreply"
              ? "bg-[#50B5FF] text-white shadow-md"
              : "text-gray-700 hover:bg-[#D5EDFF] hover:text-[#50B5FF]"
              }`}
            to="/dashboards/extrapages/pages-quickreply"
          >
                <OverlayTrigger
                placement="right"
                overlay={<Tooltip>Set quickreply</Tooltip>}
              >
            <div className={`mr-3 ${location.pathname === "/dashboards/extrapages/pages-quickreply" ? "text-white" : "text-gray-500 group-hover:text-[#50B5FF]"}`}>
              <QuickReplyIcon />
            </div>
            </OverlayTrigger>
            <span className="item-name">Quick Reply</span>
          </Link>
        </li>

        {/* Divider */}
        <li className="my-4">
          <hr className="border-gray-200" />
        </li>

        {/* Help & Support */}
        <li className="nav-item">
          <Link
            className={`nav-link flex items-center  rounded-lg text-sm font-medium transition-all duration-200 group p-3 ${location.pathname === "/dashboards/extrapages/about"
              ? "bg-[#50B5FF] text-white shadow-md"
              : "text-gray-700 hover:bg-[#D5EDFF] hover:text-[#50B5FF]"
              }`}
            to="/dashboards/extrapages/about"
          >
            <OverlayTrigger
                placement="right"
                overlay={<Tooltip>Instent support</Tooltip>}
              >
            <div className={`mr-3 ${location.pathname === "/dashboards/extrapages/about" ? "text-white" : "text-gray-500 group-hover:text-[#50B5FF]"}`}>
              <HelpIcon />
            </div>
            </OverlayTrigger>
            <span className="item-name">Help & Support</span>
          </Link>
        </li>
      </Accordion>
    </div>
  );
});

export default VerticalNav;